<template>
  <div>
    <vs-table class="border-0 border-solid border-t border-silver-gray" ref="table" :max-items="tableData.length"
      v-if="tableData && tableData.length" :data="tableData || []">
      <template slot="thead">
        <vs-th v-for="(header, idx) in headers" :key="idx" class="text-black font-semibold text-sm">
          {{ header }}
        </vs-th>
      </template>
      <template v-if="tableData && tableData.length">
        <tbody>
          <vs-tr v-for="(tr, indextr) in tableData" :key="indextr" :class="[indextr % 2 === 0 ? 'bg-soft-gray' : '']">
            <vs-td>
              {{ tr.driver_last_name + ' ' + tr.driver_name }}
            </vs-td>
            <vs-td>
              {{ tr.comment }}
            </vs-td>
            <vs-td>
              {{ tr.driver_activated }}
            </vs-td>
            <vs-td>
              {{ tr.driver_terminated }}
            </vs-td>
            <vs-td>
              {{ tr.status }}
            </vs-td>
            <vs-td>
              {{ tr.processed_time }}
            </vs-td>
            <vs-td>
              {{ tr.submission_id }}
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      required: true,
      default: [],
    }
  },
  data() {
    return {
      headers: [
        "Driver",
        "Comment",
        "Start Date",
        "End Date",
        "Status",
        "Processed Time",
        "Submission ID"
      ],
    }
  }
};
</script>

<style scoped>
/* Add any additional styles here */
</style>
